import React from 'react';

const PlainContent = (props) => {
    return (<>
        <section className={`section section-padding-bottom-90 ContentLeftImageRight ${props.bgClass} ${props.paddingClass}`}>
            <div className="container">
                <div className="row">
                    <div className="col-md-12 client-section">
                        {props.children}
                    </div>
                </div>
            </div>
        </section>
    </>)
}

export default PlainContent;